// extracted by mini-css-extract-plugin
export default {"root":"Home_root__nGPPK","content":"Home_content__zgofe","button":"Home_button__sKPQQ"};